import { ProductClusterExceptInfo } from "./product-cluster-except-info";
import { ProductConfiguration } from "./product-configuration";
import { IBlockItem } from "./iblock-list-item";
import { ProductClusterManagement } from "./product-cluster-management";

export class ProductConfigurationCluster {
  private key: string;
  private companyFiscalNumber: string;
  private productMaxCount: number;
  private productRepeatPurchase: number;
  private productFrequency: number;
  private productConfiguration: Array<ProductConfiguration>;
  private productClusterExceptInfo: ProductClusterExceptInfo;
  private blockListConfiguration: Array<IBlockItem>;
  private productClusterManagement: Array<ProductClusterManagement>;

  setKey(key: string): void {
    this.key = key;
  }

  getKey(): string {
    return this.key;
  }

  setCompanyFiscalNumber(fiscalNumber: string): void {
    this.companyFiscalNumber = fiscalNumber;
  }

  getCompanyFiscalNumber(): string {
    return this.companyFiscalNumber;
  }

  setProductConfiguration(configuration: Array<ProductConfiguration>): void {
    this.productConfiguration = configuration;
  }

  getProductConfiguration(): Array<ProductConfiguration> {
    return this.productConfiguration;
  }

  setClustersForManagement(productClusterManagement: Array<ProductClusterManagement>): void {
    this.productClusterManagement = productClusterManagement;
  }

  getClustersForManagement(): Array<ProductClusterManagement> {
    return this.productClusterManagement || ProductClusterManagement[0];
  }

  setProductClusterExceptInfo(value: ProductClusterExceptInfo): void {
    this.productClusterExceptInfo = value;
  }

  getProductClusterExceptInfo(): ProductClusterExceptInfo {
    return this.productClusterExceptInfo;
  }

  setProductMaxCount(value: number): void {
    this.productMaxCount = value;
  }

  getProductMaxCount(): number {
    return this.productMaxCount;
  }

  setBlockListConfiguration(value: Array<IBlockItem>): void {
    this.blockListConfiguration = value;
  }

  getBlockListConfiguration(): Array<IBlockItem> {
    return this.blockListConfiguration;
  }

  isNew(): boolean {
    return !this.key;
  }
  getProductRepeatPurchase(): number {
    return this.productRepeatPurchase;
  }

  setProductRepeatPurchase(ProductRepeatPurchase: number): void {
    this.productRepeatPurchase = ProductRepeatPurchase;
  }

  getProductFrequency(): number {
    return this.productFrequency;
  }
  setProductFrequency(ProductFrequency: number): void {
    this.productFrequency = ProductFrequency;
  }
}
